import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router";

import { usePermissions } from "@/app/session/permissions";
import { CREATE_ACTIONS, createHref } from "@/app/shell/createActions";
import { useT } from "@/shared/i18n/useT";
import { cn } from "@/shared/lib/cn";
import { Kbd } from "@/shared/ui/Kbd";
import { buttonVariants, menuContentClassName, menuItemClassName } from "@/shared/ui/styles";

/** The header's "Create" menu: only what this person may create. */
export function QuickCreateMenu() {
  const t = useT();
  const navigate = useNavigate();
  const permissions = usePermissions();
  const actions = CREATE_ACTIONS.filter((action) => permissions.has(action.permission));
  if (actions.length === 0) return null;

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger className={buttonVariants({ variant: "primary", size: "md" })}>
        <Plus aria-hidden="true" />
        {t("shell.quickCreate")}
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={6}
          className={cn(menuContentClassName, "min-w-56")}
        >
          {actions.map((action) => (
            <DropdownMenu.Item
              key={action.id}
              className={cn(menuItemClassName, "[&_svg]:text-ink-muted")}
              onSelect={() => void navigate(createHref(action))}
            >
              <action.icon aria-hidden="true" />
              <span className="flex-1">{t(action.labelId)}</span>
            </DropdownMenu.Item>
          ))}
          <div className="mt-1 flex items-center gap-1.5 border-t border-line px-2 pt-2 pb-1 text-[12px] text-ink-subtle">
            <Kbd>C</Kbd>
            {t("shortcuts.createHere")}
          </div>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
